export default __webpack_public_path__ + "static/LeituraTwo-Roman-dc4d15a78ae799354aa3b05546a7636b.woff2";